import styled from "styled-components";
import { spacing, typographyMixin } from "@magicbi/ui-library";

export const Heading = styled.h2`
  margin: 0;
  ${typographyMixin("heading", "h4")}
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[5]};
  padding: ${spacing[4]} ${spacing[5]} ${spacing[5]};
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${spacing[2]};
`;

export const SectionHeading = styled.h3`
  margin: 0;
  ${typographyMixin("caption", 2)}
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const Paragraph = styled.p`
  margin: 0;
  ${typographyMixin("body", 3)}
  color: ${({ theme }) => theme.colors.text.primary};
  overflow-wrap: anywhere;
  white-space: pre-line;
`;

export const Items = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${spacing[3]};
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const Item = styled.li`
  display: flex;
  flex-direction: column;
  gap: ${spacing[0.5]};
`;

export const ItemLabel = styled.span`
  ${typographyMixin("body", 3)}
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
  overflow-wrap: anywhere;
`;
